import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import * as Config from '../../app/app.config';
import {AuthProvider} from '../auth/auth';
import {ProofProvider} from '../proof/proof';
import {MediaProvider} from '../../providers/media/media';
import {FileProvider} from '../../providers/file/file';

import {Storage} from '@ionic/storage';
import {Platform} from 'ionic-angular';
import {File} from '@ionic-native/file';
import {FileUploadOptions, Transfer, TransferObject} from '@ionic-native/transfer';

import {SendingStatus} from '../../models/sendingstatus';
import {MediaItem} from '../../models/mediaitem';

import {Geolocation} from "@ionic-native/geolocation";
import {NativeGeocoder, NativeGeocoderOptions, NativeGeocoderReverseResult} from "@ionic-native/native-geocoder";
import {HttpClient} from "@angular/common/http";

/*
  Generated class for the ProofServerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ProofServerProvider {

  private medias: MediaItem[];
  // private mediasSuccess: any[];

  userIp;
  userLocation;
  proofId;
  geoData;
  dataStartAt;
  dataEndAt;
  proofIdPrincipal;


  constructor(
    private http: Http,
    private auth: AuthProvider,
    private proofProvider: ProofProvider,
    private storage: Storage,
    private platform: Platform,
    private mediaProvider: MediaProvider,
    private file: File,
    private fileProvider: FileProvider,
    private geolocation: Geolocation,
    private nativeGeocoder: NativeGeocoder,
    private httpClient: HttpClient,
  ) {
    console.log('Hello ProofServerProvider Provider');
    this.fetchGetIp();
    this.getPosition();
  }

  private sendTimeOfProof() {
  }

  fetchGetIp() {
    this.http.get(Config.urlIp).subscribe((response: Response) => {
      let data = response.json();
      if (data) {
        this.userIp = data.origin;
      }
    });
  }

  getPosition() {
    const that = this;

    that.geolocation.getCurrentPosition().then((resp) => {

      let options: NativeGeocoderOptions = {
        useLocale: true,
        maxResults: 1
      };
      if (this.platform.is('android') || this.platform.is('ios')) {
        that.nativeGeocoder.reverseGeocode(resp.coords.latitude, resp.coords.longitude, options)
            .then((result: NativeGeocoderReverseResult[]) => {
              that.userLocation = result[0];
              console.log(' that.userLocation--->' +  that.userLocation);
            })
            .catch((error: any) => {
              that.userLocation = null;
              console.log(error);
            });
      }else{
        // that.httpClient.get('https://open.mapquestapi.com/geocoding/v1/reverse?key=eUPn1zjEW0GXmIZtJJ18WeHylWQx4Ail&location='+ resp.coords.latitude+','+ resp.coords.longitude +'&includeRoadMetadata=true&includeNearestIntersection=true').subscribe((response: Response) => {
        //   if(response){
        //     let userLocation = (response["results"][0]["locations"][0]["adminArea5"]);
        //     that.userLocation = userLocation;
        //   }else{
        //     that.userLocation = null;
        //   }
        // });
      }
    }).catch((error) => {
      console.log('Error getting location', error);
    });
  }

  fetchQuestions(id: number){
    const that = this;
    return Observable.create(observer => {
      that.proofId = id;

      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/proofs/' + id + '/fetchforquestions', { headers: headers })
          .map((res: Response) => res.json())
          .subscribe((data) => {
            observer.next(data);
            observer.complete();
          }, (error: any) => {
            observer.error(new Error(error.status));
          });
    });
  }
  fetch(id: number) {
    const that = this;

    return Observable.create(observer => {
      console.log('Fetching proof: ' + id);
      that.proofId = id;
      // let headers = that.auth.createApplicationHeadersWithBearer();

      // that.storage.get('userproof_' + id).then((value: any) => {
      //   if (value) {
      //     observer.next(JSON.parse(value));
      //     observer.complete();
      //   } else {
          let headers = that.auth.createApplicationHeadersWithBearer();

          that.http.get(Config.baseUrl + '/proofs/' + id, { headers: headers })
            .map((res: Response) => res.json())
            .subscribe((data) => {
            let remainingTime = (data.remaining > 0)? (data.remaining / 60) : data.duration;
              that.storage.set('userproof_' + id, JSON.stringify(data));
            that.storage.set('userproof_' + id + '_duration', remainingTime * 60);
            that.storage.set('userproof_' + id + '_durationTotal', data.duration * 60);
            if(data.finishedAt === null && data.hasDissertation){
              that.storage.set('userproof_' + id + '_currentquestion_idx', -1);
            } else {
              that.storage.set('userproof_' + id + '_currentquestion_idx', (data.current)? data.current : -1);
            }

              console.log("Proof fetch FUNCTION ------------->", data);
              observer.next(data);
              observer.complete();
            }, (error: any) => {
              observer.error(new Error(error.status));
            });
      //   }
      // }).catch((error: any) => {
      //   observer.error(new Error(error.status));
      // });
    });
  }

  getById(id: number) {
    let that = this;

    return Observable.create(observer => {
      console.log('Get proof: ' + id);
      that.proofIdPrincipal = id;
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/proofs/' + that.proofIdPrincipal + '/getbyid', { headers: headers })
        .map((res: Response) => res.json())
        .subscribe((data) => {
          that.storage.set('proof_' + id, JSON.stringify(data));
          console.log("Proof get ------------->", data);
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  send(id: number, sendingStatus: SendingStatus, onFinish: any) {
    console.log('server.send');
    const that = this;

    // A prova existe e o id fica guardado no provider; recupera quando o parametro vem vazio
    if (!id) {
      id = that.proofId;
    }

    const proofId = id;

    if (!proofId) {
      if (sendingStatus) {
        sendingStatus.error = true;
        sendingStatus.errorMessage = 'Não foi possível identificar a prova para envio. Tente novamente sem fechar esta página; se o erro persistir, acione o fiscal.';
      }
      if (onFinish) {
        onFinish(sendingStatus);
      }
    } else {

      let that = this;
      console.log("chamei sendTimeOfProof!" + that.proofId);


      if (this.platform.is('ios') || this.platform.is('android')) {
        that.storage.get('userproof_' + that.proofId + '_duration').then((value: any) => {

          let headers = that.auth.createApplicationHeadersWithBearer();
          let data = {
            remaining : value
          }

          that.http.post(Config.baseUrl + '/proofs/' + that.proofId + '/remaining', data, { headers: headers })
              .map((res: Response) => res.json())
              .subscribe((data) => {
                console.log(data);
              });

        }, err =>{
          console.log(err)
        });
      }




      that.storage.get('userproof_' + that.proofId + '_atStartProof').then((value: any) => {
        that.dataStartAt = value;
        console.log('dataStartAt--->' + that.dataStartAt);


        if(that.dataStartAt){
          that.storage.get('userproof_' + that.proofId + '_atEndProof').then((value: any) => {

            that.dataEndAt = value;
            console.log('dataEndAt--->' + that.dataEndAt);
          }, err =>{
            console.log('dataEndAt error--->' , err)
          });





          setTimeout(() => {

            let headers = that.auth.createApplicationHeadersWithBearer();
            let proofId = id;
            let dataTimeOfProof = {
              proofId: proofId,
              startAt: that.dataStartAt,
              endAt: that.dataEndAt,
            };

            console.log('data ----->' + JSON.stringify(dataTimeOfProof));

            that.http.post(Config.baseUrl + '/proofs/' + proofId + '/timeofproof', dataTimeOfProof, { headers: headers }).subscribe((response: Response) => {
              console.log(response);
              let data = response.json();
              console.log(data);
            }, error => {
              console.log(error);
            });

          },5000)


        }

      }, err =>{
        console.log('dataStartAt error--->' , err)
      });





      if (this.platform.is('ios') || this.platform.is('android')) {

        if (this.platform.is('ios')){
          let data = {
            proofId: proofId,
            UserIP: that.userIp,
            UserLocation: that.userLocation.locality
          };

          let headers = that.auth.createApplicationHeadersWithBearer();
          that.http.post(Config.baseUrl + '/proofs/' + proofId + '/datageolocation', data, { headers: headers }).subscribe((response: Response) => {
            let data = response.json();
          }, error => {
            console.log(error);
          });
        }

        if (this.platform.is('android')){
          let data = {
            proofId: proofId,
            UserIP: that.userIp,
            UserLocation: that.userLocation.administrativeArea
          };

          let headers = that.auth.createApplicationHeadersWithBearer();
          that.http.post(Config.baseUrl + '/proofs/' + proofId + '/datageolocation', data, { headers: headers }).subscribe((response: Response) => {
            let data = response.json();
          }, error => {
            console.log(error);
          });
        }


      } else {
        let data = {
          proofId: proofId,
          UserIP: that.userIp,
          UserLocation: that.userLocation,

        };

        let headers = that.auth.createApplicationHeadersWithBearer();
        that.http.post(Config.baseUrl + '/proofs/' + proofId + '/datageolocation', data, { headers: headers }).subscribe((response: Response) => {
          let data = response.json();
        }, error => {
          console.log(error);
        });
      }
    }

    console.log(sendingStatus);
    if (sendingStatus) {
      sendingStatus.active = true;
      sendingStatus.answers.active = true;
      sendingStatus.answers.progress = false;
    }

    this.proofProvider.getAnswersAndSituations().subscribe((promises: Promise<any>[]) => {
      console.log('server.send.proofProvider.getAnswersAndSituations', promises);

      Promise.all(promises).then((values: string[]) => {
        let identificationAnswers = [];
        let answers = [];
        let situations = [];

        values.forEach((value: string) => {
          let obj = JSON.parse(value);

          if (typeof obj.kind !== 'undefined') {
            switch (obj.kind) {

              case 'IQTA':
                identificationAnswers.push(obj);
                break;

              case 'QTA':
                answers.push(obj);
                break;

              case 'QTS':
                situations.push(obj);
                break;

            }
          }
        });

        let data = {
          identificationAnswers: identificationAnswers,
          answers: answers,
          situations: situations
        };

        console.log(data);

        let headers = that.auth.createApplicationHeadersWithBearer();

        that.http.post(Config.baseUrl + '/proofs/' + id, data, { headers: headers }).subscribe((response: Response) => {
          console.log(response);

          let data = response.json();
          console.log(data);

          if (data.error) {
            if (sendingStatus) {
              sendingStatus.error = true;
              sendingStatus.errorMessage = data.error.message;
            }
          } else {
            if (sendingStatus) {
              sendingStatus.answers.done = true;
            }

            // DONE: Fix error cordova_not_available
            if (that.platform.is('cordova')) {

              if (sendingStatus) {
                sendingStatus.files.active = true;
                sendingStatus.files.progress = false;
              }

              // let medias = that.media.getMedias();
              // let mediasTotal = medias.length;
              let iMedia = -1;
              // let mediaPercent = 0;
              let currentMedia = null;

              // console.log('Medias', medias);

              //that.sendMedias(id, medias, (event: any) => {
              that.sendMedias(id, (event: any) => {
                console.log('In progress');
                console.log(event);
              }, (sucessos: any) => {
                console.log('Successful');
                console.log(sucessos);

                if (sendingStatus) {
                  sendingStatus.files.done = true;
                }

                if (sendingStatus) {
                  sendingStatus.finishing.active = true;
                }

                that.http.get(Config.baseUrl + '/proofs/' + id + '/finished', { headers: headers }).subscribe((response: Response) => {
                  console.log(response);

                  let data = response.json();
                  console.log(data);

                  that.removeStoredData(id);

                  if (sendingStatus) {
                    sendingStatus.finishing.done = true;
                  }

                  if (sendingStatus) {
                    sendingStatus.done = true;
                  }

                  if (onFinish) {
                    onFinish(sendingStatus);
                  }
                }, (error: any) => {
                  console.log(error);

                  if (sendingStatus) {
                    sendingStatus.error = true;
                    sendingStatus.errorMessage = sendingStatus.errorMessage || 'Não foi possível enviar suas respostas. Verifique sua conexão e tente novamente.';
                  }

                  if (onFinish) {
                    onFinish(sendingStatus);
                  }
                });

              }, (error: any) => {
                console.log('Something is wrong');
                console.log(error);

                if (sendingStatus) {
                  sendingStatus.error = true;
                  sendingStatus.errorMessage = sendingStatus.errorMessage || 'Não foi possível enviar suas respostas. Verifique sua conexão e tente novamente.';
                }

                if (onFinish) {
                  onFinish(sendingStatus);
                }
              }, (media: MediaItem) => {
                console.log('Media changed', media);
                if (currentMedia != null) {
                  console.log('It must be remove the media');
                }

                if (media) {
                  currentMedia = media;
                  iMedia++;
                  console.log('New media to send', iMedia, media);
                }
              });
            } else {
              if (sendingStatus) {
                sendingStatus.finishing.active = true;
              }

              that.http.get(Config.baseUrl + '/proofs/' + id + '/finished', { headers: headers }).subscribe((response: Response) => {
                console.log(response);

                let data = response.json();
                console.log(data);

                that.removeStoredData(id);

                if (sendingStatus) {
                  sendingStatus.finishing.done = true;
                }

                if (sendingStatus) {
                  sendingStatus.done = true;
                }

                if (onFinish) {
                  onFinish(sendingStatus);
                }
              }, (error: any) => {
                console.log(error);

                if (sendingStatus) {
                  sendingStatus.error = true;
                  sendingStatus.errorMessage = sendingStatus.errorMessage || 'Não foi possível enviar suas respostas. Verifique sua conexão e tente novamente.';
                }

                if (onFinish) {
                  onFinish(sendingStatus);
                }
              });
            }
          }
        }, error => {
          console.log(error);

          if (sendingStatus) {
            sendingStatus.error = true;
            sendingStatus.errorMessage = sendingStatus.errorMessage || 'Não foi possível enviar suas respostas. Verifique sua conexão e tente novamente.';
          }
        });
      }).catch((error: any) => {
        console.log('server.send.proofProvider.getAnswers.promises', error);
      });
    }, (error: any) => {
      console.log('server.send.proofProvider.getAnswers.error', error);
    });

    // let data = {
    //   // answers: this.proofProvider.getAnswers()
    // };

    // // Fire and forget
    // this.storage.keys().then((keys: string[]) => {
    //   for (let k = 0; k < keys.length; k++) {
    //     if (keys[k].includes('userproof_' + id)) {
    //       that.storage.remove(keys[k]);
    //     }
    //   }
    //   // this.storage.remove('userproof_' + id);
    //   // this.storage.remove('userproof_' + id + '_status');
    //   // this.storage.remove('userproof_' + id + '_answers');
    //   // this.storage.remove('userproof_' + id + '_files');
    // });
  }

  setCurrentQuestion(id: number, questionIdx: number, questionSeconds: number) {
    let headers = this.auth.createApplicationHeadersWithBearer();
    console.log('Setting current question: ' + questionIdx);
    return this.http.get(Config.baseUrl + '/proofs/' + id + '/current/' + questionIdx + '/' + questionSeconds, { headers: headers })
      .map((res: Response) => res.json());
  }

  sendQuestionAnswer(id: number, kind: string, questionId: any, answerId: any) {
    console.log('Sending question answer proof: ' + id);
    console.log('  + kind: ' + kind);
    console.log('  + questionId: ' + questionId);
    console.log('  + answerId: ' + answerId);

    let headers = this.auth.createApplicationHeadersWithBearer();

    return this.http.get(Config.baseUrl + '/proofs/' + id + '/question/' + kind + '/' + questionId + '/' + answerId, { headers: headers })
      .map((res: Response) => res.json())
  }

  // sendQuestionAnswer(id: number, kind: string, questionId: any, answerId: any, typeQ: any, answer: string) {
  //   console.log('Sending question answer proof: ' + id);
  //   console.log('  + kind: ' + kind);
  //   console.log('  + questionId: ' + questionId);
  //   console.log('  + answerId: ' + answerId);
  //   console.log('  + typeQ: ' + typeQ);
  //   console.log('  + typeQ: ' +  answer);

  //   let headers = this.auth.createApplicationHeadersWithBearer();

  //   return this.http.get(Config.baseUrl + '/proofs/' + id + '/question/' + kind + '/' + questionId + '/' + answerId + '/' + typeQ + '/' + answer, { headers: headers })
  //     .map((res: Response) => res.json())
  // }

  public sendMediaItem(id: number, onProgress: any, onSuccess: any, onFail: any, onNextItem: any) {
    let that = this;

    if (this.medias.length > 0) {
      let media = this.medias.shift();

      if (!media) {
        that.sendMediaItem(id, onProgress, onSuccess, onFail, onNextItem);
        return;
      }

      console.log('Sending media');
      console.log(media);

      if (onNextItem) {
        console.log('server.sendMedias.hasNextItem');
        onNextItem(media);
      }

      // If it is on APP and it's not Base64 content
      if ((this.platform.is('cordova')) && (!media.base64)) {
        let fileTransfer: TransferObject = (new Transfer()).create();

        // Bind the progress function
        fileTransfer.onProgress(onProgress);

        // Prepare our upload options
        let options = <FileUploadOptions>{
          fileKey: 'file',
          fileName: media.contentOrPath.split('/').pop(),
          // mimeType: 'image/jpeg',
          chunkedMode: false,
          headers: {
            'Content-Type': undefined,
            'Authorization': 'Bearer ' + this.auth.getToken()
          },
          params: {
            questionId: null,
            note: null,
            captured: null,
            seconds: null,
            secondsRemaining: null
          }
        };

        if (media.id) {
          options.params.id = media.id;
        }

        if (media.questionId) {
          options.params.questionId = media.questionId.toString();
        }

        if (media.note) {
          options.params.note = media.note;
        }

        if (media.extra) {
          options.params.extra = media.extra;
        }

        if (media.captured) {
          options.params.captured = media.captured;
        }

        if (media.seconds) {
          options.params.seconds = media.seconds.toString();
        }

        if (media.secondsRemaining) {
          options.params.secondsRemaining = media.secondsRemaining.toString();
        }

        // TODO: Verify if file really exists
        let transferFilePath = encodeURI(media.contentOrPath);
        let transferTargetUrl = encodeURI(Config.baseUrl + '/proofs/' + id + '/file/' +
          this.fileProvider.extractName(media.contentOrPath) + '/' + media.kind);

        fileTransfer.upload(
          transferFilePath,
          transferTargetUrl,
          options,
          false
        ).then((data) => {
          let dataResponse = JSON.parse(data.response);

          if (data.responseCode === 200) {
            // onSuccess(data);
            console.log('Media was sent');
            console.log(dataResponse);

            console.log('Remove media');
            that.storage.get('userproof_' + id + '_file_' + dataResponse.response.id).then((value: string) => {
              let item = <MediaItem>JSON.parse(value);

              that.storage.remove('userproof_' + id + '_file_' + dataResponse.response.id);

              // Try to remove old and big file
              that.file.resolveLocalFilesystemUrl(item.contentOrPath).then(entry => {
                console.log('Stored file ' + entry.name);
                entry.remove(() => {
                  console.log('Deleted');
                }, e => console.log(e));
              }).catch(e => console.log(e));
            });

            that.sendMediaItem(id, onProgress, onSuccess, onFail, onNextItem);
          } else {
            onFail({
              code: data.responseCode,
              response: dataResponse
            });
          }
        }, (error) => {
          console.log(error);
          console.log('transfer error source ' + error.source);
          console.log('transfer error target ' + error.target);
          console.log('transfer error code ' + error.code);

          // If error.code equals to FILE_NOT_FOUND_ERR
          if (error.code === 1) {
            that.sendMediaItem(id, onProgress, onSuccess, onFail, onNextItem);
          } else {
            onFail(error);
          }
        });
      } else {
        // TODO: Serve this form to mobile too
        let formData: FormData = new FormData();
        let xhr: XMLHttpRequest = new XMLHttpRequest();

        if (!media.name) {
         media.name = this.fileProvider.generateName();
        }

        // Is Web
        // TODO: Better way to retrieve type, or do not set the extension (need to try)
        // if (!this.platform.is('cordova')) {

        media.name += '.jpg';
        // }

        // Is Web
        // TODO: Better way read content, detect if it is base64 or something else
        // if (!this.platform.is('cordova')) {
        let base64ImageContent = media.contentOrPath.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
        let blob = this.fileProvider.base64ToBlob(base64ImageContent, 'image/jpeg');

        formData.append('file', blob, media.name);
        // } else {

        // }

        if (media.id) {
          formData.append('id', media.id);
        }

        if (media.questionId) {
          formData.append('questionId', media.questionId.toString());
        }

        if (media.note) {
          formData.append('note', media.note);
        }

        if (media.extra) {
          formData.append('extra', media.extra);
        }

        if (media.captured) {
          formData.append('captured', media.captured);
        }

        if (media.seconds) {
          formData.append('seconds', media.seconds.toString());
        }

        if (media.secondsRemaining) {
          formData.append('secondsRemaining', media.secondsRemaining.toString());
        }

        let transferTargetUrl = encodeURI(Config.baseUrl + '/proofs/' + id + '/file/' + media.name + '/' + media.kind);

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              // observer.next(JSON.parse(xhr.response));
              //observer.complete();

              try {
                let data = JSON.parse(xhr.response);

                console.log('Media was sent');
                console.log(data);

                console.log('Remove media');
                if (data && data.response && data.response.id) {
                  that.storage.remove('userproof_' + id + '_file_' + data.response.id);
                }
              } catch (e) {
                console.log('Falha ao ler resposta do upload de midia', e);
              }

              that.sendMediaItem(id, onProgress, onSuccess, onFail, onNextItem);
            } else {
              console.log(xhr);

              if (onFail) {
                onFail(xhr);
              }
            }
          }
        };

        xhr.upload.onprogress = (event) => {
          // console.log(event);
          if (event.lengthComputable) {
            // console.log(Math.round(event.loaded / event.total * 100));
            // this.progress = Math.round(event.loaded / event.total * 100);

            // this.progressObserver.next(this.progress);
          }
        };

        xhr.open('POST', transferTargetUrl, true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.auth.getToken());
        xhr.send(formData);
      }
    } else if (onSuccess) {
      onSuccess([]);// this.mediasSuccess);
    }
  }

  sendFile(id: Number, kind: string, fileUpload: any) {
    let formData: FormData = new FormData();
    let xhr: XMLHttpRequest = new XMLHttpRequest();

    formData.append('id', id.toString());
    formData.append('file', fileUpload, fileUpload.name);

    let transferTargetUrl = encodeURI(Config.baseUrl + '/proofs/' + id + '/file/' + fileUpload.name + '/' + kind);

    xhr.open('POST', transferTargetUrl, true);
    xhr.setRequestHeader('Authorization', 'Bearer ' + this.auth.getToken());
    xhr.send(formData);
  }

  saveAudio(blob, np3Name, questionId, kind, note, extra, captured, seconds, secondsRemaining){

    let that = this;
    let id = that.proofId;

    console.log('Cheguei no SaveAudio desde Proof-Audio' + JSON.stringify(blob)  + ' np3Name---> ' + np3Name + 'id--->' + id + 'Kind--->' + kind);
    let formDataAudio: FormData = new FormData();
    let xhr: XMLHttpRequest = new XMLHttpRequest();
    formDataAudio.append('file', blob, np3Name);

    if (id) {
      formDataAudio.append('id', id);
    }

    if (questionId) {
      formDataAudio.append('questionId', questionId.toString());
    }

    if (note) {
      formDataAudio.append('note', note);
    }

    if (extra) {
      formDataAudio.append('extra', extra);
    }

    if (captured) {
      formDataAudio.append('captured', captured);
    }

    if (seconds) {
      formDataAudio.append('seconds', seconds.toString());
    }

    if (secondsRemaining) {
      formDataAudio.append('secondsRemaining', secondsRemaining.toString());
    }

    let transferTargetUrl = encodeURI(Config.baseUrl + '/proofs/' + id + '/file/' + np3Name + '/' + kind);

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          // observer.next(JSON.parse(xhr.response));
          //observer.complete();

          try {
            let data = JSON.parse(xhr.response);

            console.log('Media Audio was sent');
            console.log(data);
          } catch (e) {
            console.log('Falha ao ler resposta do upload de audio', e);
          }
        } else {
          console.log(xhr);
        }
      }
    };

    xhr.upload.onprogress = (event) => {
      // console.log(event);
      if (event.lengthComputable) {
        // console.log(Math.round(event.loaded / event.total * 100));
        // this.progress = Math.round(event.loaded / event.total * 100);

        // this.progressObserver.next(this.progress);
      }
    };

    xhr.open('POST', transferTargetUrl, true);
    xhr.setRequestHeader('Authorization', 'Bearer ' + this.auth.getToken());
    xhr.send(formDataAudio);

  }

  setMedias(medias: MediaItem[]) {
    this.medias = medias;
  }

  sendMedias(id: number, onProgress: any = null, onSuccess: any = null, onFail: any = null, onNextItem: any = null) {
    console.log('server.sendMedias');
    let that = this;

    this.mediaProvider.getMedias().subscribe((promises: Promise<any>[]) => {
      console.log('server.send.mediaProvider.getMedias', promises);

      Promise.all(promises).then((values: string[]) => {
        that.medias = [];
        values.forEach((value: string) => {
          that.medias.push(JSON.parse(value));
        });

        that.sendMediaItem(id, onProgress, onSuccess, onFail, onNextItem);
      }).catch((error: any) => {
        console.log('server.send.mediaProvider.getMedias.promises', error);
      });
    }, (error: any) => {
      console.log('server.send.mediaProvider.getMedias.error', error);
    });
  }

  private removeStoredData(id: number) {
    let that = this;

    // Destroy current proof
    this.proofProvider.destroy();

    // Fire and forget
    this.storage.keys().then((keys: string[]) => {
      for (let k = 0; k < keys.length; k++) {
        if (keys[k].includes('userproof_' + id)) {
          that.storage.remove(keys[k]);
        }
      }
    });
  }

  /**
   * Fetch all finished proofs.
   */
  fetchFinisheds() {
    let that = this;

    return Observable.create(observer => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/proofs/finisheds', { headers: headers })
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Fetch response feedback of identified proof.
   *
   * @param id Identifier of proof.
   */
  fetchResponseFeedback(id: number) {
    let that = this;

    return Observable.create(observer => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/proofs/' + id + '/response/feedback', { headers: headers })
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Fetch response feedback of identified proof.
   *
   * @param id Identifier of proof.
   */
  fetchResponseProofFeedback(id: number) {
    let that = this;

    return Observable.create(observer => {
      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/proofs/' + id + '/prooffeedback', { headers: headers })
        .map((res: Response) => res.json())
        .subscribe((data) => {
          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Lock this proof to enable it to be taken in agnostic way (web or mobile).
   *
   * @param id Identification of Proof of User.
   */
  lock(id: number, duration: any) {
    let that = this;

    console.log('Locking proof: ' + id);

    let headers = that.auth.createApplicationHeadersWithBearer();
    let data = {
      init_time : duration
    }

    that.http.post(Config.baseUrl + '/proofs/' + id + '/lock', data, { headers: headers })
      .map((res: Response) => res.json())
      .subscribe((data) => {
        console.log('lock--->'  +data );
      });
  }
  /**
   * Sets the remaining time of the Proof.
   *
   *  @param id Identification of Proof of User.
   *  @param remaining seconds remaining from the proof duration.
   */
  setRemaining(id: number, remaining: number) {


    let that = this;

    let headers = that.auth.createApplicationHeadersWithBearer();
    let data = {
      remaining : remaining
    }

    that.http.post(Config.baseUrl + '/proofs/' + id + '/remaining', data, { headers: headers })
      .map((res: Response) => res.json())
      .subscribe((data) => {
        console.log(data);
      });
  }


  /**
   * Unlock this proof to enable it to be taken in agnostic way (web or mobile).
   *
   * @param id Identification of Proof of User.
   */
  unlock(id: number) {
    let that = this;

    return Observable.create((observer: any) => {
      console.log('Unlocking proof: ' + id);

      let headers = that.auth.createApplicationHeadersWithBearer();

      that.http.get(Config.baseUrl + '/proofs/' + id + '/unlock', { headers: headers })
        .map((res: Response) => res.json())
        .subscribe((data: any ) => {
          console.log(data);
          // that.storage.set('userproof_' + id, JSON.stringify(data));
          // that.storage.set('userproof_' + id + '_duration', data.duration * 60);
          // that.storage.set('userproof_' + id + '_currentquestion_idx', -1);

          //that.removeStoredData(id);

          observer.next(data);
          observer.complete();
        }, (error: any) => {
          observer.error(new Error(error.status));
        });
    });
  }

  /**
   * Acceptance of the terms.
   *
   *  @param id Identification of Proof of User.
   */
  public termsAcceptance(id: number): Observable<any> {
    return this.http
      .get(Config.baseUrl + "/proofs/" + id + "/terms-acceptance", {
        headers: this.auth.createApplicationHeadersWithBearer()
      })
      .map((res: Response) => res.json());
  }

  /**
   * Quantity of screens.
   *
   *  @param id Identification of Proof of User.
   *  @param data Collected data.
   */
  public screens(id: number, data: string): Observable<any> {
    console.log(data);
    return this.http
      .post(Config.baseUrl + "/proofs/" + id + "/screens", data, {
        headers: this.auth.createApplicationHeadersWithBearer()
      })
      .map((res: Response) => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/providers/proof-server/proof-server.ts